import { assign as _assign } from 'lodash';
import { FSA } from 'flux-standard-action';
import { ModalActions, ModalRegisterPayload, ModalTogglePayload } from './Modal.action';

export interface ModalReducerState {[key: string]: boolean}

const registerModal = (payload: ModalRegisterPayload, state: ModalReducerState): ModalReducerState => {
  const keys = Object.keys(state) as (keyof ModalReducerState)[];
  if (keys.indexOf(payload.id) === -1) {
    return _assign({}, state, {[payload.id]: payload.toggle});
  } else {
    console.warn(`Registering Modal failed. A Modal with the ID: "${payload.id}" already exist`);
    return state;
  }
};

const toggleModal = (payload: ModalTogglePayload, state: ModalReducerState): ModalReducerState => {
  if (state[payload.id] === undefined) {
    console.warn(`The Modal with the ID: ${payload.id} isn't registered yet.`);
    return state;
  }
  return _assign({}, state, {[payload.id]: payload.toggle !== undefined ? payload.toggle : !state[payload.id]});
};

const unRegisterModal = (id: keyof ModalReducerState, state: ModalReducerState): ModalReducerState => {
  const keys = Object.keys(state) as (keyof ModalReducerState)[];
  if (keys.indexOf(id) > -1) {
    delete state[id];
    return _assign({}, state);
  } else {
    console.warn(`A Modal with the ID: "${id}" doesn't exist`);
    return state;
  }
};

export const modalsInitialState: ModalReducerState = {}

export const hasModal= (id: keyof ModalReducerState, state: ModalReducerState): boolean => 
  Object.keys(state).indexOf(id as string) > -1; 

export const modalsReducer = (
  state: ModalReducerState = modalsInitialState, 
  action: FSA<ModalActions, ModalRegisterPayload | ModalTogglePayload | keyof ModalReducerState | undefined>): ModalReducerState => {
    switch (action.type) {
      case ModalActions.Clear:
        return modalsInitialState;
      case ModalActions.Register:
        return action.payload && registerModal(action.payload as ModalRegisterPayload, state) || state;
      case ModalActions.Toggle:        
        return action.payload && toggleModal(action.payload as ModalTogglePayload, state) || state;
      case ModalActions.UnRegister:
        return action.payload && unRegisterModal(action.payload as keyof ModalReducerState, state) || state; 
      default:
        return state;
    }
  };

